import {Component, computed, inject, Input, OnInit} from '@angular/core';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';
import {ActivatedRoute} from '@angular/router';
import {TripService} from '../../service/trip.service';
import {map, Observable} from 'rxjs';
import {TripPdfService} from '../../service/trip-pdf.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {AzureAuthService} from 'src/infrastructure/services/azure-auth.service';
import {TripWeatherRiskModalComponent} from '../trip-weather-risk-modal/trip-weather-risk-modal.component';
import {ModalService} from 'src/app/shared/service/modal/modal.service';
import {FeatureService} from 'src/infrastructure/services/feature.service';

@Component({
    selector: 'trip-details',
    templateUrl: './trip-details.component.html',
    styleUrls: ['./trip-details.component.css'],
    standalone: false
})

@AutoUnsubscribe()
export class TripDetailsComponent implements OnInit {
  @Input() data: any;
  isGeneratingPdf: boolean = false;

  public tripData$!: Observable<{ trip: any; tripId: number }>;

  private route = inject(ActivatedRoute);
  private tripService = inject(TripService);
  private tripPdfService = inject(TripPdfService);
  private snackBar = inject(MatSnackBar);
  private readonly azureAuthService = inject(AzureAuthService);
  protected readonly loggedInUserHasDirectorOrFinanceOrManagerRole = computed(() => (this.azureAuthService.checkUserAzureTokenHasManagerRole() && this.azureAuthService.checkUserAzureTokenHasFinanceRole() && this.azureAuthService.checkUserAzureTokenHasDirectorRole()));

  isHackathonTravelTipsActionEnabled: boolean = false;

  constructor(
          private modal: ModalService,
          private featureService: FeatureService
      ){}

  public ngOnInit(): void {

    this.featureService.isEnabledFeature('HackathonTravelTipsAction').subscribe((isEnabled) => {
      this.isHackathonTravelTipsActionEnabled = isEnabled;
    });

    if (this.data == null) {
      this.route.paramMap.subscribe(params => {
        this.data = {
          tripId: params.get('id'),
          pageSize: 25
        }
      });
    }

    this.getTripInformation();
  }

  getTripInformation() {
    if (this.data != null) {
      this.tripData$ = this.tripService
        .getTripLedgerById(this.data.tripId)
        .pipe(map(trip => ({ trip: trip, tripId: trip.id })));
    }
  }

  public generatePdf(): void {
    if (this.data?.tripId && !this.isGeneratingPdf) {
      this.isGeneratingPdf = true;

      this.snackBar.open('Generating Pdf...', '', {
        duration: 0,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        panelClass: ['pdf-generating-snackbar']
      });

      this.tripPdfService.generatePdfFromHtml(Number(this.data.tripId))
        .subscribe({
          next: () => {
            this.snackBar.dismiss();
            this.snackBar.open('Pdf downloaded successfully!', 'Dismiss', {
              duration: 3000,
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
              panelClass: ['pdf-success-snackbar']
            });
            this.isGeneratingPdf = false;
          },
          error: (error) => {
            this.snackBar.dismiss();
            this.snackBar.open('Pdf generation failed. Please try again.', 'Dismiss', {
              duration: 5000,
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
              panelClass: ['pdf-error-snackbar']
            });
            console.error('Pdf generation failed:', error);
            this.isGeneratingPdf = false;
          }
        });
    }
  }

  public showWeatherRisk(): void {
    const tripId = this.data?.tripId;
    if (!tripId) {
        this.snackBar.open('Trip Id not available.', 'Dismiss', { duration: 3000 });
        return;
    }

    const modalRef = this.modal.open(TripWeatherRiskModalComponent, { 
                    width: '35%',
                    height: '100%',
                    position: {right: '0'},
                    panelClass: 'overflowAuto',
                    data: tripId,
            });
            modalRef.afterClosed().subscribe((completed)=>{
                if(completed){
                  console.log('Weather Risk modal closed.');
                }
            });
            modalRef.componentInstance.title = 'Travel Weather Risk';
  }
}
